var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arrow",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.41 4.59a2 2 0 0 1 0 2.82l-6.59 6.59h23.18a2 2 0 0 1 0 4h-23.17l6.58 6.59a2 2 0 1 1 -2.82 2.82l-10-10a2 2 0 0 1 -.44-2.16 2.6 2.6 0 0 1 .17-.33v-.06a1.41 1.41 0 0 1 .2-.24s0 0 0 0l10-10a2 2 0 0 1 2.89-.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e5a8dfa0a91f9a5e1f7edc12724b195b.svg";
export { ForwardRef as ReactComponent };